/* eslint-disable import/no-cycle */
import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { withTheme } from 'styled-components'

import { buildPopularDestinationUrl } from 'helpers/popularDestinations'
import { numberWithDec } from 'helpers/utils'

import {
  Badge,
  Container,
  Description,
  Fare,
  Footer,
  Header,
  Icon,
  Image,
  PrimaryLabel,
  SecondaryLabel
} from './styled'

const DestinationThumbnail = ({ item, highlighted, theme, index }) => {
  const [selected, setSelected] = useState(undefined)
  const { i18n } = useTranslation()

  const onMouseEnter = id => setSelected(id)

  const onMouseLeave = () => setSelected(undefined)

  const getHighlightedType = item => {
    const hovered = item.id === selected ? 'primary' : false
    const first = item.highlighted || highlighted ? 'first' : false

    return hovered || first || 'info'
  }

  const getRegularType = item => (item.id === selected ? 'primary' : 'info')

  const type = highlighted ? getHighlightedType(item) : getRegularType(item)
  const formattedUrl = buildPopularDestinationUrl(item, i18n.language)

  const styles = {
    header: { info: 'transparent', primary: 'transparent', first: theme.colors.white },
    footer: { info: theme.colors.white, primary: 'transparent', first: theme.colors.white },
    image: { info: '70%', primary: '100%', first: '100%' }
  }

  return (
    <Container
      onMouseEnter={() => onMouseEnter(item.id)}
      onMouseLeave={() => onMouseLeave()}
      pathTo={formattedUrl}
      highlighted={highlighted}
      hovered={highlighted && type === 'primary'}
      size={styles.image[type]}
      height="360px"
      width="100%"
      item={item}
      index={index}
    >
      <Image src={item.image} hovered={type === 'primary'} alt={item.alt || ''} />
      <Header highlighted={highlighted} color={styles.header[type]}>
        {highlighted && (
          <Description color={styles.header[type]}>
            <SecondaryLabel dangerouslySetInnerHTML={{ __html: item.description }} />
            {item.icon && <Icon src={item.icon} />}
          </Description>
        )}
      </Header>
      <Footer highlighted={highlighted} color={styles.footer[type]}>
        {item.cabin && <Badge>{item.cabin}</Badge>}
        <Description color={styles.footer[type]}>
          <SecondaryLabel>{item.originLabel}</SecondaryLabel>
          <PrimaryLabel>{item.destinationLabel}</PrimaryLabel>
          <Fare highlighted={highlighted}>
            {item.currency} {numberWithDec(item.fare)}
          </Fare>
        </Description>
      </Footer>
    </Container>
  )
}

export default React.memo(withTheme(DestinationThumbnail))
